import { createFileRoute } from "@tanstack/react-router";
import { GlobalShell } from "~/components/GlobalShell";
import Link from "~/components/Link";

export const Route = createFileRoute("/verify-email-success")({
  component: VerifyEmailSuccessPage,
});

function VerifyEmailSuccessPage() {
  return (
    <GlobalShell>
      <div className="flex grow items-center justify-center">
        <div className="card bg-base-100 w-96  shadow-xl max-w-[90vw]">
          <div className="card-body">
            <h2 className="card-title">Email Successfully Verified</h2>
            <p>Your email has been successfully verified.</p>
            <div className="form-control mt-6">
              <Link className="btn btn-primary" href="/">
                Go to SimpleIEP
              </Link>
            </div>
          </div>
        </div>
      </div>
    </GlobalShell>
  );
}
